import axios from 'axios';
import i18n from '../i18n';

const API_BASE_URL = process.env.NODE_ENV === 'development' ? '' : '';

const passwordPolicyAPI = {
  // 获取密码策略
  getPasswordPolicy: () => {
    return axios.get(`${API_BASE_URL}/api/password-policy`);
  },

  // 更新密码策略
  updatePasswordPolicy: (data) => {
    return axios.put(`${API_BASE_URL}/api/password-policy`, data);
  },

  // 验证密码
  validatePassword: (password) => {
    return axios.post(`${API_BASE_URL}/api/password-policy/validate`, { password });
  },

  // 格式化密码要求为可读文本
  formatPasswordRequirements: (policy) => {
    const requirements = [];

    if (policy.min_length) {
      requirements.push(
        i18n.t('password_policy.requirements.min_length', {
          min: policy.min_length,
        })
      );
    }

    if (policy.require_uppercase) {
      requirements.push(
        i18n.t('password_policy.requirements.uppercase')
      );
    }

    if (policy.require_lowercase) {
      requirements.push(
        i18n.t('password_policy.requirements.lowercase')
      );
    }

    if (policy.require_numbers) {
      requirements.push(
        i18n.t('password_policy.requirements.digit')
      );
    }

    if (policy.require_special_chars) {
      requirements.push(
        i18n.t('password_policy.requirements.special')
      );
    }

    return requirements;
  }
};

export default passwordPolicyAPI;